[
  {
    "data_types": [
      "email address",
      "password",
      "first and last name",
      "phone number",
      "postal address",
      "gender",
      "date of birth"
    ],
    "category": "Personal details",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [15, 16, 17],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 47, 48, 49],
        "certainty": "high"
      },
      {
        "reason": "Process transactions or payments",
        "evidence": [50],
        "certainty": "high"
      },
      {
        "reason": "Provide customer support",
        "evidence": [50],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [57, 58, 59, 60],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": ["Payment Method", "payment history", "billing address", "gift cards and Offers"],
    "category": "Payment details",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [18],
        "certainty": "high"
      },
      {
        "reason": "Process transactions or payments",
        "evidence": [50],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 47, 48, 49],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [57, 58, 59, 60],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "sensitive"
  },
  {
    "data_types": ["purchase history", "products purchased or considered", "shopping cart"],
    "category": "Purchase information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 47, 48, 49],
        "certainty": "high"
      },
      {
        "reason": "Process transactions or payments",
        "evidence": [50],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [57, 58, 59, 60],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "profile name and icon",
      "Netflix game handle",
      "ratings and feedback",
      "My List",
      "continue watching information",
      "account/profile settings"
    ],
    "category": "Netflix account/profile information",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [20],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 47, 48, 49],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [57, 58, 59, 60],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "playback events",
      "gameplay",
      "game use and interaction information",
      "saved game information",
      "Netflix viewing and gaming history",
      "search queries",
      "voice inputs",
      "text input",
      "page views",
      "time and duration of access",
      "camera/photo access"
    ],
    "category": "Usage information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 47, 48, 49],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [57, 58, 59, 60],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "advertisements viewed or interacted with",
      "device information",
      "IP addresses",
      "inferences about household",
      "demographic information",
      "likely interests"
    ],
    "category": "Advertising information",
    "purposes": [
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [57, 58, 59, 60, 62, 63, 64, 65],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Advertisers",
        "evidence": [88, 89],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "device IDs",
      "IP addresses",
      "device and software characteristics",
      "referring source",
      "standard web browser and mobile app log information",
      "connection information",
      "crash reports",
      "timestamps",
      "debug log messages",
      "cookie data",
      "resettable device identifiers",
      "advertising identifiers"
    ],
    "category": "Device and network information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 47, 48, 49],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [57, 58, 59, 60],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["contents of communications", "details of communications", "interaction with communications"],
    "category": "Communications",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": "140, 141, 142, 143, 144, 145"
      },
      {
        "reason": "Provide customer support",
        "evidence": [29, 50],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [67, 68],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [69, 70],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "game handle",
      "friend or team list selections",
      "leaderboard status",
      "score",
      "game achievements",
      "online status",
      "gameplay",
      "text or voice chat",
      "user-generated content",
      "Netflix Game Controller information"
    ],
    "category": "Netflix Games Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [259, 260, 261, 262],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [52, 53, 54],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [263, 264, 265, 266],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [268, 269, 270],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [224],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [75, 76, 77, 78, 79],
        "certainty": "high"
      },
      {
        "party": "Partners and Affiliates",
        "evidence": [80, 81, 82],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [271, 272, 273],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [94, 95, 96],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  }
]
